import { trigger } from '@angular/animations';
import { AsyncPipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

import { animations } from '@app/animations';
import { DeviceService } from '@app/services/device.service';
import { ModalService } from '@app/services/modal.service';
import { DeviceBaseComponent } from '@app/shared/device-base.component';
import { DeviceErrorInfoTitlePipe } from '@app/shared/device-error-info-title.pipe';
import { DeviceErrorInfo } from '@app/store/device-error-info.model';
import { Device } from '@app/store/device.model';

@Component({
  animations: [trigger('navbarButtonAnimation', animations.navbarButton)],
  selector: 'app-reset-fault-button',
  templateUrl: './reset-fault-button.component.html',
  imports: [NgbTooltip, AsyncPipe, DeviceErrorInfoTitlePipe],
})
export class ResetFaultButtonComponent extends DeviceBaseComponent {
  deviceService = inject(DeviceService);
  private modalService = inject(ModalService);

  @Input() alwaysShow = false;

  errorInfo$: Observable<DeviceErrorInfo>;
  resetting$: Observable<boolean>;

  onDeviceChange(device: Device) {
    this.errorInfo$ = this.deviceService.selectDeviceErrorInfo(device);
    this.resetting$ = this.deviceService.selectDeviceFaultResetRunning(device);
  }

  onResetFault() {
    this.deviceService.requestResetDeviceFault(this.device);
  }

  onOpenDeviceErrorInfoModal() {
    this.modalService.openDeviceErrorInfoModal(this.device);
  }
}
